/**
 * 프로그램 표시명 — 사내 명명 규칙.
 *
 * 줄일 때는 반드시 아래 약어만 쓴다. '보이스웰니스'를 '보이스'로, '브레인가드테라피'를
 * '브레인가드'로 자르는 식의 임의 축약은 규칙 위반이다. 화면마다 제각각 줄이면
 * 같은 프로그램이 자리마다 다른 이름으로 보인다(실제로 시설 점수 추이 툴팁만
 * '보이스'로 나갔다).
 *
 * 어느 쪽을 쓸지는 자리 폭으로 정한다.
 *   - full : 문장·폼 라벨·안내 문구처럼 폭에 여유가 있는 곳
 *   - short: 목록 배지, 차트 툴팁·범례, 타임라인 칩, 내려받는 파일명처럼 좁은 곳
 */
export const PROGRAM_LABEL = {
  bgt: { full: '브레인가드테라피', short: 'BGT' },
  voice: { full: '보이스웰니스', short: 'VW' },
} as const;
